import './SanitySubHeader.scss';
import { SanitySubHeaderProps } from './SanitySubHeader.types';

function SanitySubHeader({ subHeader }: SanitySubHeaderProps) {
  return (
    <div className="sanity-sub-header">
      <div className="tag-line">{subHeader}</div>
    </div>
  );
}
export default SanitySubHeader;
